import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiConstants } from '../../../shared/constants/api-constants';
import { ChangeControlLookUp } from '../models/change-control-look-up';
import { ScopeLookup } from '../models/scope-lookup';
import { ChangeManagementAuthorization } from '../models/change-management-authorization';
import { UserListLookup } from '../../../shared/models/users/user-list-lookup';
import { ChangeControlDetails } from '../models/change-control-details';
import { PhaseOwnerDetails } from '../../change-control-details/models/phase-owner-details';
import { ChangeControlDisplayDetails } from '../../change-control-details/models/change-control-display-details';
import { ChangeControlLibraryConstants } from '../constants/changeControlLibraryConstants';

@Injectable({
  providedIn: 'root',
})
export class ChangeControlService {
  constructor(private httpClient: HttpClient) {}
  changeControlLookUp: ChangeControlLookUp | null = null; 

  getChangeControlLookUpDetails(): Observable<ChangeControlLookUp> {
    //If the Data is not available then we make an API call
    if (!this.changeControlLookUp || this.isLookUpDataEmpty(this.changeControlLookUp)) {
      return this.httpClient
        .get<ChangeControlLookUp>(ApiConstants.ChanageControl_LookUpDetails_Api)
        .pipe(tap((lookUpData) => (this.changeControlLookUp = lookUpData)));
    } else {
      //If data is available directly we return the data
      return of(this.changeControlLookUp);
    }
  }

  private isLookUpDataEmpty(lookUpData: ChangeControlLookUp): boolean {
    return Object.values(lookUpData).every(array => Array.isArray(array) && array.length === 0);
  }

  getScopesForChangeControl(): Observable<ScopeLookup[]> {
    return this.httpClient.get<ScopeLookup[]>(
      ApiConstants.ChanageControl_Scopes_Api
      .replace('{source}',
        ChangeControlLibraryConstants.SourceForScopes_From_Manage)
    );
  }

  getUsersForChangeControl(scopes: number[]): Observable<UserListLookup[]> {
    const requestPayload = { scopes: scopes };
    return this.httpClient.get<UserListLookup[]>(ApiConstants.ChanageControl_UserList_Api, { params: requestPayload });
  }
  
  addChangeControl(changeControlDetails: ChangeControlDetails): Observable<any> {
    return this.httpClient.post(ApiConstants.ChanageControl_AddOrUpdateChangeControl_Api, changeControlDetails);
  }

  getChangeControlById(id:string): Observable<any>{
    const headers = new HttpHeaders().set('X-No-Retry', 'true');
    return this.httpClient.get(ApiConstants.ChangeControl_GetChangeControlById_Api + `${id}`, { headers : headers });
  }

  updateChangeControl(changeControlDetails: ChangeControlDetails): Observable<any> {
    return this.httpClient.put(ApiConstants.ChanageControl_AddOrUpdateChangeControl_Api, changeControlDetails);
  }

  changeManagementAuthorization(): Observable<ChangeManagementAuthorization> {
    return this.httpClient.get<ChangeManagementAuthorization>(
      ApiConstants.ChanageControl_Authorize_Api
    );
  }
 
  updateChangeControlPhaseByPhaseOwners = (phaseOwnerDetails: PhaseOwnerDetails)
    : Observable<ChangeControlDisplayDetails> => {
    return this.httpClient.put<ChangeControlDisplayDetails>
      (ApiConstants.ChanageControl_PhaseChange_By_PhaseOwners_Api, phaseOwnerDetails);
  }

  uploadFile(file: File, foldername: string): Observable<any> {
    const formData = new FormData();
    formData.append(file.name, file);
    return this.httpClient.post(
      ApiConstants.Files_Upload_Api + foldername, formData);
  }


}
